<template>
  <div>
    <h2 class="text-center">Brake Perfomance history</h2>
    <p class="text-center">This chart shows the brake performance history of the vehicle</p>
    <!-- Show basic data -->
    <!-- Quantity of events and date of first and last event -->
    <div class="d-flex justify-content-center">
      <div class="mr-3">
        <p class="mb-0">Events: {{ filterData.length }}</p>
      </div>
      <div class="mr-3">
        <p class="mb-0">First event: {{ filterData.length > 0 ? parseDate(filterData[filterData.length - 1].date): 'No events' }}</p>
      </div>
      <div>
        <p class="mb-0">Last
          event: {{ filterData.length > 0 ? parseDate(filterData[0].date) : 'No events' }}</p>
      </div>
    </div>
    <!-- v-switch  that show all data or only 6 months-->
    <div class="d-flex justify-content-center mt-3">
      <v-switch v-model="allData" label="Use Complete History Data" color="primary"></v-switch>
    </div>
    <!-- Add tog -->
    <!-- Apex chart -->
    <apexchart type="line" height="450" :options="chartOptions" :series="series()"></apexchart>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const utc = require('dayjs/plugin/utc')
export default {
  name: 'EbpmsLineChart',
  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      allData: false,
      chartOptions: {
        chart: {
          id: 'ebpms-line-chart',
          type: 'line',
          zoom: {
            enabled: false,
            allowMouseWheelZoom: false
          },
          height: 550,
          toolbar: {
            show: true
          }
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          min: 30,
          max: 70,
          tickAmount: 4
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy HH:mm'
          }
        },
        grid: {
          show: true,
          borderColor: '#f1f1f1',
          strokeDashArray: 0, // Solid lines
          row: {
            colors: undefined, // No background color for rows
            opacity: 0.5
          },
          column: {
            colors: undefined, // No background color for columns
            opacity: 0.5
          },
          xaxis: {
            lines: {
              show: true // Show vertical grid lines
            }
          },
          yaxis: {
            lines: {
              show: true // Show horizontal grid lines
            }
          }
        },
        fill: {
          type: ['solid', 'gradient', 'solid'], // Enable gradient fill for this series
          gradient: {
            shade: 'light',
            type: 'vertical', // Gradient direction
            shadeIntensity: 0.5,
            gradientToColors: ['#ed564e'], // End color of the gradient
            inverseColors: false,
            opacityFrom: 0.5, // Starting opacity
            opacityTo: 0.8, // Ending opacity
            stops: [0, 50, 100] // Gradient stops
          }
        }
      }
    }
  },
  computed: {
    filterData () {
      if (this.allData) {
        return this.data
      } else {
        return this.data.filter((item) => {
          return dayjs().diff(dayjs(item.date * 1000), 'month') <= 6
        })
      }
    }
  },
  methods: {
    parseDate (date) {
      dayjs.extend(utc)
      if (date === null) {
        return dayjs()
      } else {
        return dayjs(date * 1000).format('DD/MM/YYYY HH:mm')
      }
    },
    calculateLineSeries () {
      return this.filterData.map((item) => {
        return [new Date(item.date * 1000), item.value.toFixed(2)]
      })
    },
    calculateAreaSeries () {
      // Get the calculate line series and for the y value put 45
      return this.filterData.map((item) => {
        return [new Date(item.date * 1000), 45]
      })
    },
    calculateLinearRegression () {
      const n = this.filterData.length
      if (n === 0) return []

      // Calculate sums for regression formula
      const sumX = this.filterData.reduce((sum, item) => sum + item.date, 0)
      const sumY = this.filterData.reduce((sum, item) => sum + item.value, 0)
      const sumXY = this.filterData.reduce((sum, item) => sum + item.date * item.value, 0)
      const sumX2 = this.filterData.reduce((sum, item) => sum + item.date * item.date, 0)

      // Calculate slope (m) and intercept (b)
      const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX)
      const intercept = (sumY - slope * sumX) / n

      // Generate regression line points
      return this.filterData.map((item) => {
        return [new Date(item.date * 1000), (slope * item.date + intercept).toFixed(2)]
      })
    },
    series () {
      return [
        {
          name: 'EBPMS value',
          type: 'line',
          data: this.calculateLineSeries(),
          color: '#305CDE' // Optional: Set a specific color for the line
        },
        {
          name: 'Threshold',
          type: 'area',
          data: this.calculateAreaSeries(),
          color: '#ed564e' // Optional: Set a base color for the area
        },
        {
          name: 'Trend',
          type: 'line',
          data: this.calculateLinearRegression(),
          color: '#008000' // Optional: Set a specific color for the regression line
        }
      ]
    }
  }
}
</script>